import { FormEvent } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { AxiosResponse } from 'axios';
import _ from 'lodash';

import { DraggablePhotos } from '../../shared';

import {
    ImageFileUploading,
    onSelectPhoto,
    OptionalData,
} from '../../utils/upload';

import { BannerMediaTypes, MediaType } from '../../types/enums/mediatype.enum';

import { Media } from '../../types/mediaTypes';

const NoMediaPlaceholder = () => (
    <div className="noMediaWrapper">
        <label className="placeholder">
            No files, just yet. Click 'Add new' to upload
        </label>
    </div>
);

type BannerMediaProps = {
    filename: string;
    items: (Media | (ImageFileUploading & { id?: number }))[];
    header: string;
    type: BannerMediaTypes;
    onMediaDragEnd: (result: {
        source: { index: number; droppableId: MediaType };
        destination: { index: number };
    }) => void;
    onMediaSelect: (
        type: MediaType,
        items: ImageFileUploading[],
        optionalData: OptionalData,
    ) => void;
    onMediaWasUploaded: (
        type: MediaType,
        file: File,
        res: AxiosResponse<{ uploaded: Media }>,
    ) => void;
    onMediaDelete?: (index: number, type: MediaType) => void;
    imageSize?: string;
    buttonLabel?: string;
    onProcessingComplete?: (media: Media) => void;
    onProcessingError?: (mediaId: number) => void;
};

export const BannerMedia = (props: BannerMediaProps) => {
    const {
        items,
        header,
        type,
        onMediaDragEnd,
        onMediaSelect,
        onMediaWasUploaded,
        onMediaDelete,
        buttonLabel,
        onProcessingComplete,
        onProcessingError,
    } = props;
    const imageSize = props.imageSize || '@1x';

    const onAddNewClicked = (e: FormEvent<HTMLInputElement>) =>
        onSelectPhoto(e, type, onMediaSelect, onMediaWasUploaded);

    return (
        <div className="part">
            <h2>{header}</h2>
            <DndProvider backend={HTML5Backend}>
                {_.isEmpty(items) && <NoMediaPlaceholder />}
                <DraggablePhotos
                    onDelete={onMediaDelete}
                    type={type}
                    items={items}
                    onDragEnd={onMediaDragEnd}
                    imageSize={imageSize}
                    onProcessingComplete={onProcessingComplete}
                    onProcessingError={onProcessingError}
                />
                <div style={{ marginTop: 20 }}>
                    <input
                        type="file"
                        multiple={false}
                        name={type}
                        id={type}
                        accept="Image/png"
                        onChange={onAddNewClicked}
                    />
                    <label className="upload" htmlFor={type}>
                        {buttonLabel || 'Add new'}
                    </label>
                </div>
            </DndProvider>
        </div>
    );
};
